import configs from 'config';
import ls from 'utils/secureStorage';

export const persistUrl = () => {
  const value = ls.get(configs.PERSIST_URL) ?? '' as string;

  return value;
};
